/*
*
* File JS per la Section Page Custom
*
*/


// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import blockQuote from 'components/block-quote/block-quote';
import blockChartInfograph from 'components/block-chart-infograph/block-chart-infograph';
import blockDownload from 'components/block-download/block-download';
import blockText from 'components/block-text/block-text';
import blockMedia from 'components/block-media/block-media';
import blockTextImg from 'components/block-text-img/block-text-img';
import blockBulletedList from 'components/block-bulleted-list/block-bulleted-list';
import blockSliderOffScreen from 'components/block-slider-off-screen/block-slider-off-screen';
import blockCarousel from 'components/block-carousel/block-carousel';
import blockBannerFeatured from 'components/block-banner-featured/block-banner-featured';
import blockCards from 'components/block-cards/block-cards';
import blockSolarEdge from 'components/block-solaredge/block-solaredge';

//--------------------------------------------------------------------//


// IMPORT STILE SPECIFICO SECTION
//--------------------------------------------------------------------//

// import './section-page-custom.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//



//--------------------------------------------------------------------//

// EXPORT
//--------------------------------------------------------------------//

const sectionPageCustom = () => {
    blockText();

    blockSliderOffScreen();

    blockCarousel();

    blockSolarEdge()
}

export default sectionPageCustom;

//--------------------------------------------------------------------//